export default "__VITE_ASSET__ab19f8da__"